/* Modish (Global): re-centre product photos that sit low in a white frame (supplier shots with the product at the bottom).
   Reads a 48px copy of each loaded product image, finds the product, and if it sits well below centre,
   shifts and gently enlarges it inside its frame. Centred photos are left untouched.
   Ported from the India theme; frame maths handle both object-fit: cover (Desert cards) and contain. */
(function () {
  var SEL = '.product-card-wrapper .media-wrapper img, .product-gallery-slider .media-wrapper img, .product-gallery-thumb-item .media-wrapper img, media-gallery .media-wrapper img';
  var cache = {};
  function key(img) { return ((img.currentSrc || img.src || '').split('?')[0]); }
  function analyse(img) {
    var k = key(img);
    if (!k) return null;
    if (k in cache) return cache[k];
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return null;
    var w = 48, h = Math.max(1, Math.round(48 * nh / nw));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true }), d;
    try { x.drawImage(img, 0, 0, w, h); d = x.getImageData(0, 0, w, h).data; } catch (e) { cache[k] = null; return null; }
    var t = h, b = -1, l = w, r = -1;
    for (var yy = 0; yy < h; yy++) {
      for (var xx = 0; xx < w; xx++) {
        var i = (yy * w + xx) * 4;
        if (d[i + 3] > 10 && (0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]) < 236) {
          if (yy < t) t = yy; if (yy > b) b = yy; if (xx < l) l = xx; if (xx > r) r = xx;
        }
      }
    }
    cache[k] = b < 0 ? null : { t: t / h, b: (b + 1) / h, l: l / w, r: (r + 1) / w, ar: nw / nh };
    return cache[k];
  }
  function apply(img) {
    if (!img || img.tagName !== 'IMG' || img.dataset.mdRc || !img.matches(SEL)) return;
    if (!img.clientWidth || !img.clientHeight) return;
    var p = analyse(img);
    if (!p) return;
    img.dataset.mdRc = '1';
    var cy = (p.t + p.b) / 2;
    if (!(p.t > 0.2 && cy > 0.58)) return;
    var ca = img.clientWidth / img.clientHeight;            // frame width in units of frame height
    var cover = getComputedStyle(img).objectFit === 'cover';
    var rw, rh;
    if ((p.ar > ca) !== cover) { rw = ca; rh = ca / p.ar; } else { rh = 1; rw = p.ar; }
    var ox = (ca - rw) / 2, oy = (1 - rh) / 2;
    var x0 = Math.max(0, ox + p.l * rw), x1 = Math.min(ca, ox + p.r * rw);
    var y0 = Math.max(0, oy + p.t * rh), y1 = Math.min(1, oy + p.b * rh);
    if (x1 <= x0 || y1 <= y0) return;
    var s = Math.min(0.86 * ca / (x1 - x0), 0.86 / (y1 - y0));
    s = Math.max(1, Math.min(1.35, s));
    var tx = (ca / 2 - s * (x0 + x1) / 2) / ca * 100, ty = (0.5 - s * (y0 + y1) / 2) * 100;
    img.style.transformOrigin = '0 0';
    img.style.transform = 'translate(' + tx.toFixed(2) + '%,' + ty.toFixed(2) + '%) scale(' + s.toFixed(3) + ')';
    img.classList.add('md-rc');
  }
  document.addEventListener('load', function (e) { apply(e.target); }, true);
  function scan() { document.querySelectorAll(SEL).forEach(function (img) { if (img.complete && img.naturalWidth) apply(img); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  // infinite scroll / filter updates add new cards
  var q = 0;
  new MutationObserver(function () { if (q) return; q = requestAnimationFrame(function () { q = 0; scan(); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
